import * as React from "react";
const SvgSchedule = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M15.987 2.66663C8.62699 2.66663 2.66699 8.63996 2.66699 16C2.66699 23.36 8.62699 29.3333 15.987 29.3333C23.3603 29.3333 29.3337 23.36 29.3337 16C29.3337 8.63996 23.3603 2.66663 15.987 2.66663ZM16.0003 26.6666C10.107 26.6666 5.33366 21.8933 5.33366 16C5.33366 10.1066 10.107 5.33329 16.0003 5.33329C21.8937 5.33329 26.667 10.1066 26.667 16C26.667 21.8933 21.8937 26.6666 16.0003 26.6666ZM14.667 9.33329H16.667V16.3333L22.667 19.8933L21.667 21.5333L14.667 17.3333V9.33329Z",
	fill: "currentColor"
}));
export default SvgSchedule;
